import axios from "axios";
import { getAccessToken } from "lib/accessToken";
import { getFromLocalStorage } from "lib/common/helper/LocalStorage";
import { Error } from "lib/common/types/ErrorResponse";
import myaxios from "lib/myAxios";

import { useCallback, useEffect, useState } from "react";

import { host } from "../../../utils/constants";
import usePut from "../usePut";
import { message as _message } from "antd";

function useUploadImage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const {
    data: data_put,
    isLoading,
    error: error_put,
    put,
  } = usePut<{ message: string; success: boolean }>(
    host + "/auth/user_profile_picture",
  );

  useEffect(() => {
    if (error) {
      _message?.error(error?.message ?? "Image upload failed. Please try a different photo or check your connection.");
    } else if (message) {
      _message?.success(message);
    }
  }, [error, message]);

  const uploadImage = useCallback(
    (value, filename, reload) => {
      setLoading(true);
      setError(null);
      if (getAccessToken()) {
        const formdata = new FormData();
        formdata.append("file", value, filename);
        put(formdata, reload);
      } else {
        const token = getFromLocalStorage("registerToken");

        const formdata = new FormData();
        if (token) {
          formdata.append("file", value, filename);
          formdata.append("token", token);
        }

        axios({
          method: "put",
          url: host + `/auth/user_profile_picture`,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: formdata,
        })
          .then(({ data: { success, message } }) => {
            setSuccess(success);
            setMessage(message);
            if (reload) window?.location.reload();
          })
          .catch((err) => {
            setError(err.response.data);
          })
          .finally(() => setLoading(false));
      }
    },
    [put],
  );

  return { uploadImage, loading, error, success };
}

export default useUploadImage;
